import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { cn } from '../lib/cn.js';
export const Skeleton = React.forwardRef(({ className, ...props }, ref) => (_jsx("div", { ref: ref, className: cn('animate-pulse rounded-[var(--radius-2)] bg-[var(--color-surface-sunken)]', className), ...props })));
Skeleton.displayName = 'Skeleton';
//# sourceMappingURL=skeleton.js.map